import React from 'react';

import { CommunityActivityType } from 'types/communities';

import ActivityBubbleMessage from './ActivityBubbleMessage';
import ActivityBubbleOperations from './ActivityBubbleOperations';
import { ACTIVITY_CATEGORY } from './constants';

type ActivityBubbleProps = {
  activity: CommunityActivityType;
  communityId?: number;
  showRenderedBody: boolean;
  onToggleRenderedBody: () => void;
  onActivityUpdated?: () => void | Promise<unknown>;
};

const isBubbleActivity = (activity: CommunityActivityType) =>
  activity.category_slug === ACTIVITY_CATEGORY.COMMUNICATION;

const ActivityBubble = ({
  activity,
  communityId,
  showRenderedBody,
  onToggleRenderedBody,
  onActivityUpdated,
}: ActivityBubbleProps) => {
  if (!isBubbleActivity(activity)) {
    return <ActivityBubbleOperations activity={activity} />;
  }

  return (
    <ActivityBubbleMessage
      activity={activity}
      communityId={communityId}
      showRenderedBody={showRenderedBody}
      onToggleRenderedBody={onToggleRenderedBody}
      onActivityUpdated={onActivityUpdated}
    />
  );
};

export default ActivityBubble;
